<script lang="ts">
    import {clickOutside} from "../../helpers/event";
    import {fly} from 'svelte/transition';
    import WishlistInner from "./WishlistInner.svelte";

    export let hide: Function;

</script>

<div class="wishList" use:clickOutside on:click_outside={hide} transition:fly="{{y:200, duration: 300 }}">
    <WishlistInner {hide}/>
</div>

<style>
    .wishList {
        background-color: white;
        border: 1px solid #8080808c;
        height: 75vh;
        margin-bottom: 5px;
        box-shadow: 0px 1px 1px rgb(0 0 0 / 25%), 0 5px 5px rgb(0 0 0 / 22%);
        padding: 10px 5px 3px 5px;
        min-width: 340px;
    }

    .wishlist-arrow {
        width: 0;
        content: "";
        height: 0;
        border-style: solid;
        border-width: 20px 15px 0;
        border-color: #66676b transparent transparent;
        /*top: 100%;*/
        /*right: 50px;*/
        transform: translatey(54px) translateX(255px);
        /*position: absolute;*/
        border-radius: 0;
        z-index: 1;
        border-color: #a8a3a3 transparent transparent;
        transition: all ease-in .3s;
    }

    :global(.redirect-button) {
        width: 50%;
    }
</style>